// Site switches, written by tools/build/flags.mjs: the website build embeds them from its environment variables
// (docs/CLOUDFLARE_DEPLOYMENT.md). Git holds the defaults.
export const BILLBOARDS = true;   // BILLBOARDS=off: nothing to click on the billboards (no "Your business here?", no card)
export const LIVE_FEATURES = true;   // LIVE_FEATURES=off: pages never connect to the live worker (no pill, chat or Together)
